import React, { useRef, useState } from "react";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import Service from "../Service/http";

// Function to get column name using number
function getColumn(columnNumber) {
  let columnName = [];
  while (columnNumber > 0) {
    let rem = columnNumber % 26;
    if (rem === 0) {
      columnName.push("Z");
      columnNumber = Math.floor(columnNumber / 26) - 1;
    }
    else {
      columnName.push(String.fromCharCode((rem - 1) + 'A'.charCodeAt(0)));
      columnNumber = Math.floor(columnNumber / 26);
    }
  }
  return (columnName.reverse().join(""));
}

const siteCode = {
  "CODECHEF": 'CC',
  "CODEFORCES": "CF",
  "HACKERRANK": "HR",
  "INTERVIEWBIT": "IB",
  "SPOJ": "SJ",
  "VJUDGE": "VJ",
  "MENTORPICK": "MP",
  "LEETCODE": "LC"
}
// *Maintain keys according to ProfileStatsModel if the column exists within it.
const columnCode = {
  solved_count: "SC",
  solved_in_practice: "PSC",
  solved_in_contest: "CSC",
  contests_participated: "CP",
  user_rating: "RA",
  score: "S",
  highest_rating: "HR",
  star_rating: "ST",
  hackerrank_data_structures_score: "DS",
  hackerrank_algorithms_score: "A",
  sincerety_score:"SNC",
  recent_contest: "RC",
  rank: "RK"
}

const siteMap = {
  codechef: "CODECHEF",
  codeforces: "CODEFORCES",
  leetcode: "LEETCODE",
  mentorpick: "MENTORPICK",
  vjudge: "VJUDGE",
  spoj: "SPOJ",
  hackerrank: "HACKERRANK",
  interviewbit: "INTERVIEWBIT"
}

const ExcelExportHelper = ({ formulas, formulaColumns, maindata, sitesOptions, criteria, fullCriteria, batch }) => {

  const includeFollowUps = useRef(false)
  const [loading, setLoading] = useState(false)

  const makeFormula = (siteName, isSummary = false, isTotal = false) => {
    let formulaString = "";
    const sites = Object.keys(formulas);
    //Total Score Formula
    if (isTotal) {
      for (let site of sites) {
        formulaString += `+${siteCode[site]}`;
      }
    }
    //Summary Score Formula
    if (isSummary) {
      const columns = formulaColumns[siteName];
      const formula = formulas[siteName];
      for (let column of columns) {
        formulaString += `+${siteCode[siteName]}${columnCode[column]}*${formula[column]}`;
      }
      formulaString = formulaString.slice(1);
      formulaString = `${siteCode[siteName]}=` + formulaString;
    }
    return formulaString;
  };
  

  let rangeMap = { "USERDETAILS": "A1:F1" }
  let criteriaLen = 0;
  let colorMap = {
    CODECHEF: "ebfdff",
    CODEFORCES: "D6F073",
    HACKERRANK: "fffbf8",
    LEETCODE: "dff1f0",
    INTERVIEWBIT: "f1fff4",
    SPOJ: "fff8e1",
    VJUDGE: "f7e5e3",
    MENTORPICK:"b3d1ff"
  }
  //Function to modify leaderboard data
  const modifyLB = async (data, sitesOptions) => {
    let table = [
      {
        A: "USER DETAILS",
        B: "",
        C: "",
        D: "",
        E: "",
        F: "",
      },
      {
        A: "Rank",
        B: "Name",
        C: "Sincerity Score",
        D: "Roll No",
        E: "Email",
        F: "Mentorpick Username",
      }
    ];
    let count = 7 ;
    if (sitesOptions.find((ele) => ele === "CODECHEF") !== undefined) {
      rangeMap["CODECHEF"] = getColumn(count) + "1:" + getColumn(count + 5 ) + "1"
      table[0][getColumn(count)] = 'CODECHEF'
      table[1][getColumn(count++)] = "Contest Solved Count\n" + `${siteCode?.CODECHEF}${columnCode?.solved_in_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = "Practice Solved Count\n" + `${siteCode?.CODECHEF}${columnCode?.solved_in_practice}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = "Total Solved Count\n" + `${siteCode?.CODECHEF}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Contest Participated\n' + `${siteCode?.CODECHEF}${columnCode?.contests_participated}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Recent Contest\n' + `${siteCode?.CODECHEF}${columnCode?.recent_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'User Rating\n'+ `${siteCode?.CODECHEF}${columnCode?.user_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Highest Rating\n' + `${siteCode?.CODECHEF}${columnCode?.highest_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Stars\n' + `${siteCode?.CODECHEF}${columnCode?.star_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'CodeChef Score\n'+ makeFormula(siteMap?.codechef, true)
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Codechef Last Activity'
    }
    if (sitesOptions.find((ele) => ele === "CODEFORCES") !== undefined) {
      rangeMap["CODEFORCES"] = getColumn(count) + "1:" + getColumn(count + 3) + "1"
      table[0][getColumn(count)] = 'CODEFORCES'
      table[1][getColumn(count++)] = 'Contest Solved Count\n' + `${siteCode?.CODEFORCES}${columnCode?.solved_in_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Practice Solved Count\n' + `${siteCode?.CODEFORCES}${columnCode?.solved_in_practice}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Total Solved Count\n' + `${siteCode?.CODEFORCES}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Contest Participated\n' + `${siteCode?.CODEFORCES}${columnCode?.contests_participated}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Recent Contest\n' + `${siteCode?.CODEFORCES}${columnCode?.recent_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'User Rating\n' + `${siteCode?.CODEFORCES}${columnCode?.user_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Highest Rating\n' + `${siteCode?.CODEFORCES}${columnCode?.highest_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'CodeForces Score\n' + makeFormula(siteMap?.codeforces, true)
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Codeforces Last Activity'
    }
    if (sitesOptions.find((ele) => ele === "HACKERRANK") !== undefined) {
      rangeMap["HACKERRANK"] = getColumn(count) + "1:" + getColumn(count + 2) + "1"
      table[0][getColumn(count)] = 'HACKERRANK'
      table[1][getColumn(count++)] = 'Data Structure\n' + `${siteCode?.HACKERRANK}${columnCode?.hackerrank_data_structures_score}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Algorithms\n' + `${siteCode?.HACKERRANK}${columnCode?.hackerrank_algorithms_score}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Badge stars\n' + `${siteCode?.HACKERRANK}${columnCode?.star_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'HackerRank Score\n' + makeFormula(siteMap?.hackerrank, true)
    }
    if (sitesOptions.find((ele) => ele === "LEETCODE") !== undefined) {
      rangeMap["LEETCODE"] = getColumn(count) + "1:" + getColumn(count + 2) + "1"
      table[0][getColumn(count)] = 'LEETCODE'
      table[1][getColumn(count++)] = 'Contest Solved Count\n' + `${siteCode?.LEETCODE}${columnCode?.solved_in_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Practice Solved Count\n' + `${siteCode?.LEETCODE}${columnCode?.solved_in_practice}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Total Solved Count\n' + `${siteCode?.LEETCODE}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Contest Participated\n' + `${siteCode?.LEETCODE}${columnCode?.contests_participated}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Recent Contest\n' + `${siteCode?.LEETCODE}${columnCode?.recent_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Rating\n' + `${siteCode?.LEETCODE}${columnCode?.user_rating}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'LeetCode Score\n' + makeFormula(siteMap?.leetcode, true)
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Leetcode Last Activity'

    }
    if (sitesOptions.find((ele) => ele === "INTERVIEWBIT") !== undefined) {
      rangeMap["INTERVIEWBIT"] = getColumn(count) + "1:" + getColumn(count + 1) + "1"
      table[0][getColumn(count)] = 'INTERVIEWBIT'
      table[1][getColumn(count++)] = 'Score\n' + `${siteCode?.INTERVIEWBIT}${columnCode?.score}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Rank\n' + `${siteCode?.INTERVIEWBIT}${columnCode?.rank}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'InterviewBit Score\n' + makeFormula(siteMap?.interviewbit, true)
    }
    if (sitesOptions.find((ele) => ele === "SPOJ") !== undefined) {
      rangeMap["SPOJ"] = getColumn(count) + "1:" + getColumn(count + 1) + "1"
      table[0][getColumn(count)] = 'SPOJ'
      table[1][getColumn(count++)] = 'Solved Count\n' + `${siteCode?.SPOJ}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Rank\n' + `${siteCode?.SPOJ}${columnCode?.rank}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'SPOJ Score\n' + makeFormula(siteMap?.spoj, true)
    }
    if (sitesOptions.find((ele) => ele === "VJUDGE") !== undefined) {
      rangeMap["VJUDGE"] = getColumn(count) + "1:" + getColumn(count) + "1"
      table[0][getColumn(count)] = 'VJUDGE'
      table[1][getColumn(count++)] = 'Solved Count\n' + `${siteCode?.VJUDGE}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'VJUDGE Score\n' + makeFormula(siteMap?.vjudge, true)
    }
    if (sitesOptions.find((ele) => ele === "MENTORPICK") !== undefined) {
      rangeMap["MENTORPICK"] = getColumn(count) + "1:" + getColumn(count+2) + "1"
      table[0][getColumn(count)] = 'MENTORPICK'
      table[1][getColumn(count++)] = 'Solved Count\n' + `${siteCode?.MENTORPICK}${columnCode?.solved_count}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Contest Participated\n' + `${siteCode?.MENTORPICK}${columnCode?.contests_participated}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Recent Contest\n' + `${siteCode?.MENTORPICK}${columnCode?.recent_contest}`
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Mentorpick Score\n' + makeFormula(siteMap?.mentorpick, true)
      table[0][getColumn(count)] = ""
      table[1][getColumn(count++)] = 'Mentorpick Last Activity'
    }
    rangeMap["CRAWL TIME"] = getColumn(count) + "1:" + getColumn(count) + "1"
    table[0][getColumn(count)] = 'CRAWL TIME'
    table[1][getColumn(count++)] = 'Last Updated'
    rangeMap["TOTAL"] = getColumn(count) + "1:" + getColumn(count + 1) + "1"
    table[0][getColumn(count)] = 'TOTAL'
    table[1][getColumn(count++)] = 'Red Flags'
    table[0][getColumn(count)] = ""
    table[1][getColumn(count++)] = 'Score'
    table[0][getColumn(count)] = ""
    table[1][getColumn(count++)] = 'Global Rank'
    table[0][getColumn(count)] = ""
    table[1][getColumn(count)] = 'Last Activity'
    if (includeFollowUps.current === true) {
      table[1][getColumn(++count)] = 'Follow Ups'
    }
    let style = JSON.parse(JSON.stringify(table));
    for (let x of style) {
      for (let y in x) {
        x[y] = {
          fontColor: "000000",
          fill: "f6f6f6",
          wrapText: true,
        }
      }
    }

    let usersFollowUpData = {}
    if (includeFollowUps.current === true) {
      let service = new Service();
      const userIds = data.map((user) => user.user_id)
      usersFollowUpData = await service.post(`api/users/followups`, { userIds })
    }

    data.forEach((row) => {
      let styleObj = {
        A: {
          fontColor: "000000",
          fill: "0f98d9",
          wrapText: true
        },
        B: {
          fontColor: "000000",
          fill: "7dc280",
          wrapText: true
        },
        C: {
          fontColor: "000000",
          fill: "b1eaf1"
        },
        D: {
          fontColor: "000000",
          fill: "b1eaf1"
        },
        E: {
          fontColor: "000000",
          fill: "b1eaf1"
        },
        F: {
          fontColor: "000000",
          fill: "b1eaf1"
        },
      }
      let obj = {
        A: row.no,
        B: row.name,
        C: row.sincerity_score,
        D: row.roll_number,
        E: row.email,
        F: row.mentorpick_id,
      }
      let count = 7 ;
      if (sitesOptions.find((ele) => ele === "CODECHEF") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.codechef_solved_count) && row?.codechef_solved_count < criteria.CODECHEF.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_solved_in_contest
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.codechef_solved_count) && row?.codechef_solved_count < criteria.CODECHEF.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_solved_in_practice
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.codechef_solved_count) && row?.codechef_solved_count < criteria.CODECHEF.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.contest_participated) && row?.codechef_contest_participated < criteria.CODECHEF.contest_participated) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_contest_participated
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.codechef_most_recent_contest_participated
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.user_rating) && row?.codechef_user_rating < criteria.CODECHEF.user_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_user_rating
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.highest_rating) && row?.codechef_highest_rating < criteria.CODECHEF.highest_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_highest_rating
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.star_rating) && row?.codechef_star_rating < criteria.CODECHEF.star_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_star_rating
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: ((criteria?.CODECHEF?.codechef_summary_score) && row?.codechef_summary_score < criteria.CODECHEF.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codechef_summary_score
        styleObj[getColumn(count)] = { fill: colorMap["CODECHEF"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.codechef_last_active
      }
      if (sitesOptions.find((ele) => ele === "CODEFORCES") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.codeforces_solved_count) && row?.codeforces_solved_count < criteria.CODEFORCES.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_solved_in_contest
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.codeforces_solved_count) && row?.codeforces_solved_count < criteria.CODEFORCES.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_solved_in_practice
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.codeforces_solved_count) && row?.codeforces_solved_count < criteria.CODEFORCES.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.contests_participated) && row?.codeforces_contests_participated < criteria.CODEFORCES.contests_participated) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_contests_participated
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.codeforces_most_recent_contest_participated
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.user_rating) && row?.codeforces_user_rating < criteria.CODEFORCES.user_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_user_rating
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.highest_rating) && row?.codeforces_highest_rating < criteria.CODEFORCES.highest_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_highest_rating
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: ((criteria?.CODEFORCES?.codeforces_summary_score) && row?.codeforces_summary_score < criteria.CODEFORCES.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.codeforces_summary_score
        styleObj[getColumn(count)] = { fill: colorMap["CODEFORCES"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.codeforces_last_active
      }
      if (sitesOptions.find((ele) => ele === "HACKERRANK") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["HACKERRANK"], fontColor: ((criteria?.HACKERRANK?.hackerrank_data_structures_score) && row?.hackerrank_data_structures_score < criteria.HACKERRANK.hackerrank_data_structures_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.hackerrank_data_structures_score
        styleObj[getColumn(count)] = { fill: colorMap["HACKERRANK"], fontColor: ((criteria?.HACKERRANK?.hackerrank_algorithms_score) && row?.hackerrank_algorithms_score < criteria.HACKERRANK.hackerrank_algorithms_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.hackerrank_algorithms_score
        styleObj[getColumn(count)] = { fill: colorMap["HACKERRANK"], fontColor: ((criteria?.HACKERRANK?.hackerrank_star_rating) && row?.hackerrank_star_rating < criteria.HACKERRANK.hackerrank_star_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.hackerrank_star_rating
        styleObj[getColumn(count)] = { fill: colorMap["HACKERRANK"], fontColor: ((criteria?.HACKERRANK?.hackerrank_summary_score) && row?.hackerrank_summary_score < criteria.HACKERRANK.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.hackerrank_summary_score
      }
      if (sitesOptions.find((ele) => ele === "LEETCODE") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.solved_count) && row?.leetcode_solved_count < criteria.LEETCODE.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_solved_in_contest
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.solved_count) && row?.leetcode_solved_count < criteria.LEETCODE.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_solved_in_practice
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.solved_count) && row?.leetcode_solved_count < criteria.LEETCODE.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.contests_participated) && row?.leetcode_contests_participated < criteria.LEETCODE.contests_participated) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_contests_participated
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE) && (row?.leetcode_most_recent_contest_participated === "NA")) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_most_recent_contest_participated
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.user_rating) && row?.leetcode_user_rating < criteria.LEETCODE.user_rating) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_user_rating
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: ((criteria?.LEETCODE?.leetcode_summary_score) && row?.leetcode_summary_score < criteria.LEETCODE.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.leetcode_summary_score
        styleObj[getColumn(count)] = { fill: colorMap["LEETCODE"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.leetcode_last_active
      }
      if (sitesOptions.find((ele) => ele === "INTERVIEWBIT") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["INTERVIEWBIT"], fontColor: ((criteria?.INTERVIEWBIT?.score) && row?.interviewbit_score < criteria.INTERVIEWBIT.score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.interviewbit_score
        styleObj[getColumn(count)] = { fill: colorMap["INTERVIEWBIT"], fontColor: ((criteria?.INTERVIEWBIT?.rank) && row?.interviewbit_rank < criteria.INTERVIEWBIT.rank) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.interviewbit_rank
        styleObj[getColumn(count)] = { fill: colorMap["INTERVIEWBIT"], fontColor: ((criteria?.INTERVIEWBIT?.interviewbit_summary_score) && row?.interviewbit_summary_score < criteria.INTERVIEWBIT.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.interviewbit_summary_score
      }
      if (sitesOptions.find((ele) => ele === "SPOJ") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["SPOJ"], fontColor: ((criteria?.SPOJ?.solved_count) && row?.spoj_solved_count < criteria.SPOJ.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.spoj_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["SPOJ"], fontColor: ((criteria?.SPOJ?.rank) && row?.spoj_rank < criteria.SPOJ.rank) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.spoj_rank
        styleObj[getColumn(count)] = { fill: colorMap["SPOJ"], fontColor: ((criteria?.SPOJ?.spoj_summary_score) && row?.spoj_summary_score < criteria.SPOJ.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.spoj_summary_score
      }
      if (sitesOptions.find((ele) => ele === "VJUDGE") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["VJUDGE"], fontColor: ((criteria?.VJUDGE?.solved_count) && row?.vjudge_solved_count < criteria.VJUDGE.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.vjudge_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["VJUDGE"], fontColor: ((criteria?.VJUDGE?.vjudge_summary_score) && row?.vjudge_summary_score < criteria.VJUDGE.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.vjudge_summary_score
      }
      if (sitesOptions.find((ele) => ele === "MENTORPICK") !== undefined) {
        styleObj[getColumn(count)] = { fill: colorMap["MENTORPICK"], fontColor: ((criteria?.MENTORPICK?.solved_count) && row?.mentorpick_solved_count < criteria.MENTORPICK.solved_count) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.mentorpick_solved_count
        styleObj[getColumn(count)] = { fill: colorMap["MENTORPICK"], fontColor: ((criteria?.MENTORPICK?.contests_participated) && row?.mentorpick_contests_participated < criteria.MENTORPICK?.contests_participated) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.mentorpick_contests_participated
        styleObj[getColumn(count)] = { fill: colorMap["MENTORPICK"], fontColor:  '009d00' }
        obj[getColumn(count++)] = row.recent_contest_participated
        styleObj[getColumn(count)] = { fill: colorMap["MENTORPICK"], fontColor: ((criteria?.MENTORPICK?.mentorpick_summary_score) && row?.mentorpick_summary_score < criteria.MENTORPICK.summary_score) ? 'ef5350' : '009d00' }
        obj[getColumn(count++)] = row.mentorpick_summary_score
        styleObj[getColumn(count)] = { fill: colorMap["MENTORPICK"], fontColor: '009d00' }
        obj[getColumn(count++)] = row.mentorpick_last_active
      }
      styleObj[getColumn(count)] = { fill: "b2e4fb", fontColor: "000000" }
      obj[getColumn(count++)] = row.user_last_crawled_at
      styleObj[getColumn(count)] = { fill: (row?.red_flag != 0) ? 'ef5350' : '009d00', fontColor: "ffffff" }
      obj[getColumn(count++)] = row.red_flag
      styleObj[getColumn(count)] = { fill: "0f98d9", fontColor: "ffffff" }
      obj[getColumn(count++)] = row.total_score
      styleObj[getColumn(count)] = { fill: "7cbf7e", fontColor: "ffffff" }
      obj[getColumn(count++)] = row.global_rank
      styleObj[getColumn(count)] = { fill: "7cbf7e", fontColor: "ffffff" }
      obj[getColumn(count++)] = row.lastActiveTime
      if (includeFollowUps.current === true) {
        let followUpString = ``
        const followUpData = usersFollowUpData[row.user_id]
        if (followUpData) {
          followUpData.forEach((followup) => {
            followUpString += `updated by: ${followup.updated_by}\ncreatedAt: ${new Date(followup.createdAt).toLocaleString()}\nupdatedAt: ${new Date(followup.updatedAt).toLocaleString()}\nPoints: ${followup.followup_points}\nmessage: ${followup.message}\n\n\n\n`
          })
        }
        obj[getColumn(count++)] = followUpString
      }
      table.push(obj)
      style.push(styleObj)
    })
    return { table, style }
  }

  //Function to modify Criteria data
  const modifyCriteria = () => {
    let table = [
      { A: batch },
      {
        A: "PLATFORM",
        B: "METRIC",
        C: "MINIMUM QUALIFICATION CRITERIA"
      }
    ]
    for (let c of fullCriteria) {

      let cobj = {
        A: c.platform,
        B: c.metric,
        C: c.mqc
      }
      table.push(cobj)
    }
    criteriaLen = table.length
    return table
  }
  const createDownLoadData = () => {
    setLoading(true)
    handleExport().then((url) => {
      const date = new Date();
      const date_options = { weekday: undefined, year: 'numeric', month: 'long', day: 'numeric' };
      const download_title = batch + ' ' + date.toLocaleDateString(undefined, date_options) + ' ' + date.toLocaleTimeString('en-US');
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", url);
      downloadAnchorNode.setAttribute("download", download_title.split(' ').join('-') + ".xlsx");
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    })
    .catch(err => {
      console.error(err)
    })
    .finally(() => {
      setLoading(false)
    })
  };
  
  const workbook2blob = (workbook) => {
    const wopts = {
      bookType: "xlsx",
      bookSST: false,
      type: "binary",
    };

    const wbout = XLSX.write(workbook, wopts);

    // The application/octet-stream MIME type is used for unknown binary files.
    // It preserves the file contents, but requires the receiver to determine file type,
    // for example, from the filename extension.
    const blob = new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    });

    return blob;
  };

  const s2ab = (s) => {
    // The ArrayBuffer() constructor is used to create ArrayBuffer objects.
    // create an ArrayBuffer with a size in bytes
    const buf = new ArrayBuffer(s.length);


    //create a 8 bit integer array
    const view = new Uint8Array(buf);

    //charCodeAt The charCodeAt() method returns an integer between 0 and 65535 representing the UTF-16 code
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i);
    }

    return buf;
  };

  const handleExport = async () => {
    const { table, style } = await modifyLB(maindata, sitesOptions);
    let criteriaData
    if(fullCriteria){
      criteriaData = modifyCriteria();
    }
    let finalData = table


    //create a new workbook
    const wb = XLSX.utils.book_new();
    if(fullCriteria){
      const sheet2 = XLSX.utils.json_to_sheet(criteriaData, {
        skipHeader: true,
      });
      XLSX.utils.book_append_sheet(wb, sheet2, "Criteria");
    }
    const sheet = XLSX.utils.json_to_sheet(finalData, {
      skipHeader: true,
    });

    XLSX.utils.book_append_sheet(wb, sheet, "Leaderboard");

    // binary large object
    // Since blobs can store binary data, they can be used to store images or other multimedia files.

    const workbookBlob = workbook2blob(wb);

    return addStyle(workbookBlob, style);
  };

  const addStyle = (workbookBlob, style) => {
    return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {

      //Function to style Leaderboard
      const styleLB = (sheet) => {
        sheet.usedRange().style({
          fontFamily: "Arial",
          fontSize: 10,
          verticalAlignment: "center",
          horizontalAlignment: "center",

        });
        sheet.column("B").width(60);
        sheet.column("AS").width(25);
        for (let head in rangeMap) {
          sheet.range(rangeMap[head]).merged(true).style({
            bold: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
          });
        }

        for (let i = 0; i < style.length; i++) {
          for (let x in style[i]) {
            let r = x + String(i + 1) + ":" + x + String(i + 1)
            sheet.range(r).style(style[i][x]);
          }
        }
      }

      //Function to style Criteria
      const styleCriteria = (sheet) => {
        sheet.usedRange().style({
          fontFamily: "Arial",
          fontSize: 11,
          verticalAlignment: "center",
          horizontalAlignment: "center",
          bold: true,
        });
        sheet.range("A1:C1").merged(true).style({
          bold: true,
          horizontalAlignment: "center",
          verticalAlignment: "center",
        });
        sheet.column("A").width(14);
        sheet.column("B").width(26);
        sheet.column("C").width(33);


        sheet.range("A2:C2").style({ bold: true });
        sheet.range("A3:A" + String(criteriaLen)).style({ fill: "f06292", fontColor: "ffffff" });
        sheet.range("B3:B" + String(criteriaLen)).style({ fill: "64b5f5", fontColor: "ffffff" });
        sheet.range("C3:C" + String(criteriaLen)).style({ fill: "4db6ac", fontColor: "ffffff" });
      }
      if(fullCriteria){
        styleCriteria(workbook.sheets()[0])
        styleLB(workbook.sheets()[1]);
      }
      else{
        styleLB(workbook.sheets()[0]);
      }
      return workbook
        .outputAsync()
        .then((workbookBlob) => URL.createObjectURL(workbookBlob));
    });
  };

  return (
    <>
      <div
        className="btn-group dropstart"
        style={{
          cursor: "pointer",
          position: "absolute",
          right: 10,
          top: 0,
          zIndex: 100,
        }}
      >
        <button
          type="button"
          className="btn btn-secondary dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          disabled={loading}
        >
          {loading && (
            <>
              <span
                class="spinner-border spinner-border-sm"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden" role="status">
                Loading...
              </span>
            </>
          )}
          Download
        </button>
        <ul class="dropdown-menu">
          <li>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => {
                includeFollowUps.current = false;
                createDownLoadData();
              }}
            >
              Download (Faster)
            </button>
          </li>
          <li>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => {
                includeFollowUps.current = true;
                createDownLoadData();
              }}
            >
              Download with Follow-ups (Slower)
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ExcelExportHelper;
